<template>
	<div class="container">
		<div class="sub_top">
			<div class="top_content">
				<div class="headline">
					<p class="sub_title">
						{{ $t('rtr_personal-how-online_shopping.title1') }}
					</p>
					<p class="sub_text">
						{{ $t('rtr_personal-how-online_shopping.text1') }}<br />
						{{ $t('rtr_personal-how-online_shopping.text2') }}
					</p>

					<div class="button_area">
						<button
							class="button_bg_red mr_10"
							@click="$router.push({ name: 'auth-register' })"
						>
							{{ $t('button.signup') }}
						</button>
						<button class="button_bg_black" @click="notYet">
							{{ $t('button.down') }}
						</button>
					</div>
				</div>
			</div>
		</div>

		<section>
			<div class="sub_content1">
				<p class="catch_text fw_500">
					{{ $t('rtr_personal-how-online_shopping.text3') }}
					<span>{{ $t('rtr_personal-how-online_shopping.text4') }}</span
					>{{ $t('rtr_personal-how-online_shopping.text5') }}<br />
					{{ $t('rtr_personal-how-online_shopping.text6') }}
				</p>
				<div class="section01">
					<div class="d_flex justify_center">
						<div class="area">
							<div class="circle">
								<img
									src="@/assets/images/sub/online_shopping_icon_01.png"
									alt=""
								/>
							</div>
							<p class="text01">
								{{ $t('rtr_personal-how-online_shopping.text7') }}<br />
								{{ $t('rtr_personal-how-online_shopping.text8') }}
							</p>
						</div>
						<div class="area base">
							<span class="arrow"></span>
						</div>
						<div class="area">
							<div class="circle">
								<img
									src="@/assets/images/sub/online_shopping_icon_02.png"
									alt=""
								/>
							</div>
							<p class="text01">
								{{ $t('rtr_personal-how-online_shopping.text9') }}<br />
								{{ $t('rtr_personal-how-online_shopping.text10') }}
							</p>
						</div>
						<div class="area base">
							<span class="arrow"></span>
						</div>
						<div class="area">
							<div class="circle">
								<img
									src="@/assets/images/sub/online_shopping_icon_03.png"
									alt=""
								/>
							</div>
							<p class="text01">
								{{ $t('rtr_personal-how-online_shopping.text11') }}<br />
								{{ $t('rtr_personal-how-online_shopping.text12') }}
							</p>
						</div>
					</div>
				</div>
			</div>
		</section>

		<section>
			<div class="sub_content">
				<div class="d_flex">
					<div class="detail_area">
						<div class="detail">
							<h2 class="title">
								{{ $t('rtr_personal-how-online_shopping.title2') }}<br />
								{{ $t('rtr_personal-how-online_shopping.title3') }}
							</h2>
							<p class="text">
								{{ $t('rtr_personal-how-online_shopping.text13') }}<br />
								{{ $t('rtr_personal-how-online_shopping.text14') }}<br />
								{{ $t('rtr_personal-how-online_shopping.text15') }}<br />
								{{ $t('rtr_personal-how-online_shopping.text16') }}
							</p>
						</div>
					</div>
					<div class="img_area">
						<img
							class="w80"
							src="@/assets/images/sub/online_shopping_02.png"
							alt=""
						/>
					</div>
				</div>
			</div>
		</section>

		<section>
			<div class="sub_content">
				<div class="d_flex">
					<div class="img_area">
						<img
							class="w70"
							src="@/assets/images/sub/online_shopping_03.png"
							alt=""
						/>
					</div>
					<div class="detail_area">
						<div class="detail">
							<h2 class="title">
								{{ $t('rtr_personal-how-online_shopping.title4') }}<br />
								{{ $t('rtr_personal-how-online_shopping.title5') }}
							</h2>
							<p class="text">
								{{ $t('rtr_personal-how-online_shopping.text17') }}<br />
								{{ $t('rtr_personal-how-online_shopping.text18') }}<br />
								{{ $t('rtr_personal-how-online_shopping.text19') }}
							</p>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
export default {
	name: 'OnlineShopping',
	methods: {
		notYet() {
			alert(this.$t('alert.not_yet'));
		},
	},
};
</script>
